import React from 'react';

const Experience = () => {
  const experiences = [
    {
      company: "Amazon",
      role: "Software Development Engineer - ML Intern",
      team: "Nova AGI Team",
      location: "Sunnyvale, CA",
      period: "May 2025 - Aug 2025",
      achievements: [
        "Implemented model- and infrastructure-level hyperparameter optimization using validation loss and GPU utilization as composite metrics",
        "Integrated LoRA into Nova's PPO fine-tuning pipeline with NVIDIA Megatron-LM, NeMo, and TensorRT-LLM on AWS EKS",
        "Optimized Bedrock's Nova PPO customization pipeline, reducing training memory footprint by 48% and increasing throughput by 12%"
      ],
      gradient: "gradient-1"
    },
    {
      company: "Homekynd",
      role: "Machine Learning Engineer Intern",
      location: "Austin, TX",
      period: "Jan 2025 - May 2025",
      achievements: [
        "Built and deployed RESTful Cloud Run endpoints serving multiple ML models (CNN for couch placement, U-Net for removal), handling 200+ daily requests",
        "Implemented optimal furniture prediction using CNN, bounding boxes, and mean-squared-error loss for precise localization",
        "Containerized inference with Docker and accelerated training on GCP GPU VMs (Tesla P400)"
      ],
      gradient: "gradient-2"
    },
    {
      company: "Iontra",
      role: "Software Engineer Intern",
      location: "Austin, TX",
      period: "May 2024 - Aug 2024",
      achievements: [
        "Developed an Angular-based Pinmux configuration tool with real-time validation, conflict detection, and streamlined pin assignments",
        "Created a customizable SDK for user-defined hardware integrations, writing production-quality code in Python and C"
      ],
      gradient: "gradient-3"
    }
  ];

  return (
    <section id="experience" className="experience">
      <div className="container">
        <h2 className="section-title">Experience</h2>
        <div className="experience-timeline">
          {experiences.map((exp, index) => (
            <div key={index} className="experience-item">
              <div className={`experience-icon ${exp.gradient}`}>
                <i className="fas fa-briefcase"></i>
              </div>
              <div className="experience-content">
                <div className="experience-header">
                  <h3 className="experience-role">{exp.role}</h3>
                  <h4 className="experience-company">{exp.company}{exp.team && ` - ${exp.team}`}</h4>
                  <div className="experience-meta">
                    <span className="experience-location"><i className="fas fa-map-marker-alt"></i> {exp.location}</span>
                    <span className="experience-period"><i className="fas fa-calendar"></i> {exp.period}</span>
                  </div>
                </div>
                <ul className="experience-achievements">
                  {exp.achievements.map((achievement, idx) => (
                    <li key={idx}>{achievement}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;

